import { Navigate } from 'react-router-dom';
import { useStore } from '../context';
import { ClientCategory, Roles } from '../types';
import { getDefaultRouter, showToRoles, showToRolesMobile } from '../utils';

interface RoleGuardProps {
  roles: Array<Roles | ClientCategory> | 'admin' | 'adminRead' | 'client';
  redirectTo?: string;
  negative?: boolean;
  isMobile?: boolean;
  children: any;
  withoutRedirect?: boolean;
}

export const RoleGuard = ({
  roles,
  redirectTo = getDefaultRouter(),
  negative = false,
  isMobile = false,
  children,
  withoutRedirect = false,
}: RoleGuardProps) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  if (
    !isMobile &&
    ((showToRoles(roles, user) && !negative) || (negative && !showToRoles(roles, user)))
  ) {
    return children;
  }

  if (
    isMobile &&
    ((showToRolesMobile(roles, user) && !negative) || (negative && !showToRolesMobile(roles, user)))
  ) {
    return children;
  }

  if (withoutRedirect) {
    return <></>;
  }

  return <Navigate to={redirectTo} replace />;
};
